import React from "react";
import "./Business.css";

import useBusiness from "./hooks/useBusiness";

import BusinessProfile from "./components/BusinessProfile";
import BusinessHours from "./components/BusinessHours";
import AddressSection from "./components/AddressSection";
import BankDetails from "./components/BankDetails";
import DocumentsSection from "./components/DocumentsSection";
import WalletCard from "./components/WalletCard";
import RatingCard from "./components/RatingCard";
import StatusCard from "./components/StatusCard";

const Business = () => {
  const {
    business,
    address,
    bankDetails,
    wallet,

    loading,
    saving,
    error,

    saveBusinessProfile,
    saveBusinessHours,
    saveAddress,
    saveBank,
    saveStatus,
    savePhotos,
    saveDocuments,
  } = useBusiness();

  if (loading) {
    return (
      <div className="business-loading">
        Loading Business Details...
      </div>
    );
  }

  return (
    <div className="business-page">

      {/* Header */}
      <div className="business-header">
        <div>
          <h2>🏪 Business Management</h2>
          <p>
            Manage your business profile, business hours,
            address, documents, bank details and wallet.
          </p>
        </div>

        <div className="completion-card">
          <h4>Profile Completion</h4>

          <div className="progress">
            <div className="progress-fill"></div>
          </div>

          <span>85%</span>
        </div>
      </div>

      {error && (
        <div className="business-error">
          {error}
        </div>
      )}

      {/* Stats */}
      <div className="stats-grid">

        <WalletCard wallet={wallet} />

        <RatingCard business={business} />

        <StatusCard
          business={business}
          saving={saving}
          onSave={saveStatus}
        />

      </div>

      {/* Row 1 */}
      <div className="business-grid">

        <BusinessProfile
          business={business}
          saving={saving}
          onSave={saveBusinessProfile}
        />

        <BusinessHours
          business={business}
          saving={saving}
          onSave={saveBusinessHours}
        />

      </div>

      {/* Row 2 */}
      <div className="business-grid">

        <AddressSection
          address={address}
          saving={saving}
          onSave={saveAddress}
        />

        <BankDetails
          bankDetails={bankDetails}
          saving={saving}
          onSave={saveBank}
        />

      </div>

      {/* Documents */}
      <DocumentsSection
        business={business}
        saving={saving}
        onSavePhotos={savePhotos}
        onSaveDocuments={saveDocuments}
      />

    </div>
  );
};

export default Business;